/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StudyProgramDTO,
    StudyProgramDTOFromJSON,
    StudyProgramDTOFromJSONTyped,
    StudyProgramDTOToJSON,
} from './StudyProgramDTO';

/**
 * 
 * @export
 * @interface StudyProgramDTOPagedResponse
 */
export interface StudyProgramDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StudyProgramDTO>}
     * @memberof StudyProgramDTOPagedResponse
     */
    data?: Array<StudyProgramDTO> | null;
}

export function StudyProgramDTOPagedResponseFromJSON(json: any): StudyProgramDTOPagedResponse {
    return StudyProgramDTOPagedResponseFromJSONTyped(json, false);
}

export function StudyProgramDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProgramDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(StudyProgramDTOFromJSON)),
    };
}

export function StudyProgramDTOPagedResponseToJSON(value?: StudyProgramDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(StudyProgramDTOToJSON)),
    };
}

